module.exports = {
      id: "user-usage",
      viewBox: "0 0 496 512",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#user",
      toString: function () {
        return this.url;
      }
    }